import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import axios from "axios";

import authHeader from "../../../../services/auth-header";
import { API } from "../../../../backend";
import { getTrans as t } from "../../../../Localization/translations";
import AddRatecardService from "../../../../services/inventory/ratecardAddServices";
import Helper from "../../../../Helper";
import ButtonLoading from "../../../../components/Loder/buttonLoading";

function EditRateCardHeader() {
  const [effectiveformdate, setEffectiveFormdate] = useState(null);
  const [effectivetodate, setEffectiveTodate] = useState(null);
  const [total_amount, setTotal_Amount] = useState(0);
  const [cardname, setCardName] = useState("");
  const [loading, setLoading] = useState(false);
  const [successful, setSuccessful] = useState(false);
  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const form = useRef();
  const [category, setCategory] = useState([]);
  const [subcategory, setSubcategory] = useState([]);
  const { state } = useLocation();
  const [rowsData, setRowsData] = useState([]);

  const addTableRows = () => {
    const rowsInput = {
      category: "",
      subcategory: "",
      frequency: "",
      term: 0,
      termto: 0,
      ratebasis: "",
      amount: 0,
      product: "",
    };
    setRowsData([...rowsData, rowsInput]);
  };

  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
    totalInvoiceAmount();
  };

  const handleChange = (index, evnt) => {
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    setRowsData(rowsInput);
  };

  const totalInvoiceAmount = () => {
    let total = 0;
    Object.entries(rowsData).forEach(([key, value]) => {
      total = parseFloat(total) + parseFloat(value.amount);
    });
    setTotal_Amount(total);
  };

  const handleEffectiveForm = (value) => {
    setEffectiveFormdate(value);
    reset({
      effectiveformdate: value,
    });
  };
  const handleEffectiveTo = (value) => {
    setEffectiveTodate(value);
    reset({
      effectivetodate: value,
    });
  };

  const loadOptions2 = async () => {
    const response = await axios.get(API + "inventory/load-category/", {
      headers: authHeader(),
    });
    setCategory(await response.data);
  };
 
  const getsubcategory = async (id) => {
    const resst = await fetch(API + "inventory/load-subcategoryall/");
    const getst = await resst.json();
    setSubcategory(await getst);
  };

  useEffect(() => {
    getsubcategory();
  }, []);
  useEffect(() => {
    AddRatecardService.getratecard(state).then((response) => {
      setCardName(response.data.cardname);
      setEffectiveFormdate(response.data.effectiveform);
      setEffectiveTodate(response.data.effectiveto);
      setRowsData(response.data.ratecardline);
      reset({
        effectiveformdate: response.data.effectiveform,
        effectivetodate: response.data.effectiveto,
        cardname: response.data.cardname,
      });
    });
  }, []);

  useEffect(() => {
    loadOptions2();
  }, []);

  useEffect(() => {
    addTableRows();
  }, []);

  const navigate = useNavigate();
  const [disable,setDisable] = useState(false)

  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true);
    setDisable(true)
    let effectiveto_date = null;
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      if (effectivetodate !==null) {
        effectiveto_date =  Helper.DatePicker(effectivetodate)
      }
      else {
        setEffectiveTodate(effectivetodate)
      }
      AddRatecardService.editRatecard(
        state,
        cardname,
        Helper.DatePicker(effectiveformdate),
        effectiveto_date,
        rowsData
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
          setTimeout(() => {
            setDisable(false)
            navigate("/ratecard");
          }, 2000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
          setLoading(false);
          setDisable(false)
        }
      })
    }
  };

  const handelClick = () => {
    navigate("/ratecard");
  };

  return (
    <div className="page-wrapper">
      <ToastContainer />
      <div className="content container-fluid">
        <div className="header pb-0 mb-3 pt-3">
          <div>
            <h5 >{t("Edit Ratecard")}</h5>
            <h6>
              <Link to="" className="tc">
                {t("Rate Card")}
              </Link>{" "}
              / <span>{t("Edit Ratecard")}</span>{" "}
            </h6>
            <div className="show_invoice">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="success"></div>
                      <Form
                        role="form text-left"
                        onSubmit={handleSubmit(handleRegister)}
                        ref={form}
                        action="."
                        method="POST"
                        id="addPartyForm"
                      >
                        {
                          <>
                            <input
                              type="hidden"
                              value=""
                              id="invoiceid"
                              name="invoiceid"
                            />
                            <input
                              type="hidden"
                              value=""
                              id="invoiceno"
                              name="invoiceno"
                            />
                            <div className="row">
                              <div className="col-xl-3">
                                <div className="form-group row">
                                  <label className="col-lg-12 col-form-label">
                                    {t("Card Name")}{" "}
                                    <Tooltip content={t("CardName_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <div className="col-lg-12">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="cardname"
                                      name="cardname"
                                      value={cardname}
                                      {...register("cardname", {
                                        onChange: (e) => {
                                          setCardName(e.target.value);
                                        },
                                        required: true,
                                      })}
                                    ></input>
                                    <div className="invalid-feedback">
                                      {errors.cardname?.type === "required" &&
                                        "Card Name is required"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* </div> */}
                              <div className="row">
                                <div className="col-xl-3">
                                  <div className="form-group row">
                                    <label className="col-lg-12 col-form-label">
                                      {t("Effective From")}{" "}
                                      <Tooltip content={t("EffectiveFrom_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </label>
                                    <div className="col-lg-12">
                                      <DatePicker
                                        {...register("effectiveformdate", {
                                          required: true,
                                        })}
                                        className="form-control datepick"
                                        selected={
                                          effectiveformdate
                                            ? new Date(effectiveformdate)
                                            : ""
                                        }
                                        onChange={(e) => handleEffectiveForm(e)}
                                        name="effectiveformdate"
                                        placeholderText={"mm/dd/yyyy"}
                                        showYearDropdown // year show and scrolldown alos
                                        scrollableYearDropdown
                                        showMonthDropdown
                                        dropdownMode="select"
                                      />
                                      <div className="invalid-feedback">
                                        {errors.effectiveformdate &&
                                          "Effective Form  is required"}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-3">
                                  <label className="col-lg-12 col-form-label">
                                    {t("Effective To")}{" "}
                                    <Tooltip content={t("EffectiveTo_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <div className="col-lg-12">
                                    <DatePicker
                                      {...register("effectivetodate", {
                                        required: false,
                                      })}
                                      className="form-control datepick"
                                      selected={
                                        effectivetodate
                                          ? new Date(effectivetodate)
                                          : ""
                                      }
                                      onChange={(e) => handleEffectiveTo(e)}
                                      name="effectivetodate"
                                      placeholderText={"mm/dd/yyyy"}
                                      showYearDropdown // year show and scrolldown alos
                                      scrollableYearDropdown
                                      showMonthDropdown
                                      dropdownMode="select"
                                    />
                                    <div className="invalid-feedback">
                                      {errors.effectivetodate &&
                                        "Effective To is required"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="table-responsive">
                              <div className="row pt-3">
                                <div className="col-xl-6">
                                  <label className="col-form-label">
                                    {t("Ratecard Lines")}
                                  </label>
                                </div>
                                <div className="col-xl-6">
                                  <div className="text-right ">
                                    <button
                                      type="button"
                                      className="btn btn-outline-success"
                                      onClick={addTableRows}
                                    >
                                      + {t("ADD")}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <table
                                id="invoice"
                                className="table table-nowrap mb-0"
                              >
                                <thead>
                                  <th>
                                    {t("index")}{" "}
                                    <Tooltip content={t("ratecardline_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Category")}{" "}
                                    <Tooltip content={t("Category_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Sub Category")}{" "}
                                    <Tooltip content={t("SubCategory_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Frequency")}{" "}
                                    <Tooltip content={t("FrequencyRate_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Term From")}{" "}
                                    <Tooltip content={t("TermFrom_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Term To")}{" "}
                                    <Tooltip content={t("TermTo_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Rate Basis")}{" "}
                                    <Tooltip content={t("Ratebasis_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Amount")}{" "}
                                    <Tooltip content={t("Amountrate_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                  <th>
                                    {t("Product")}{" "}
                                    <Tooltip content={t("Product_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </th>
                                </thead>
                                <tbody>
                                  {rowsData.map((data, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>
                                        <select
                                          type="text"
                                          placeholder="Category"
                                          value={data.category}
                                          onChange={(evnt) =>
                                            handleChange(index, evnt)
                                          }
                                          name="category"
                                          className="form-control"
                                        >
                                          <option value="">
                                            ---{t("Select Category")}---
                                          </option>
                                          {category.map((key) => (
                                            <option key={key.id} value={key.id}>
                                              {key.name}
                                            </option>
                                          ))}
                                        </select>
                                      </td>
                                      <td>
                                        <select
                                          type="text"
                                          placeholder="Sub Category"
                                          value={data.subcategory}
                                          onChange={(evnt) =>
                                            handleChange(index, evnt)
                                          }
                                          name="subcategory"
                                          className="form-control"
                                          // disabled={!data.category}
                                        >
                                          <option value="">
                                            ---{t("Select Sub Category")}---
                                          </option>
                                          {subcategory.map((subCategory) => (
                                            <option
                                              key={subCategory.id}
                                              value={subCategory.id}
                                            >
                                              {subCategory.name}
                                            </option>
                                          ))}
                                        </select>
                                      </td>
                                      <td>
                                        <select
                                          type="text"
                                          placeholder="frequency"
                                          value={data.frequency}
                                          onChange={(evnt) =>
                                            handleChange(index, evnt)
                                          }
                                          name="frequency"
                                          className="form-control"
                                        >
                                          <option value="">
                                            ---{t("Select Frequency")}---
                                          </option>
                                          <option value="Monthly">
                                            {t("Monthly")}
                                          </option>
                                          <option value="Quarterly">
                                            {t("Quarterly")}
                                          </option>
                                          <option value="Semi-Annual">
                                            {t("Semi-Annual")}
                                          </option>
                                          <option value="Annual">
                                            {t("Annual")}
                                          </option>
                                        </select>
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          placeholder="Term From"
                                          value={data.term}
                                          onChange={(evnt) =>
                                            handleChange(index, evnt)
                                          }
                                          name="term"
                                          className="form-control"
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          placeholder="Term To"
                                          value={data.termto}
                                          onChange={(evnt) =>
                                            handleChange(index, evnt)
                                          }
                                          name="termto"
                                          className="form-control"
                                        />
                                      </td>
                                      <td>
                                        <select
                                          type="text"
                                          placeholder="Rate Basis"
                                          value={data.ratebasis}
                                          onChange={(evnt) =>
                                            handleChange(index, evnt)
                                          }
                                          name="ratebasis"
                                          className="form-control"
                                        >
                                          <option value="">
                                            ---{t("Select Rate Basis")}---
                                          </option>
                                          <option value="Amount">
                                            {t("Amount")}
                                          </option>
                                          <option value="Money Factor">
                                            {t("Money Factor")}
                                          </option>
                                        </select>
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control required"
                                          value={data.amount}
                                          onChange={(evnt) =>
                                            handleChange(index, evnt)
                                          }
                                          name="amount"
                                        />
                                      </td>
                                      <td>
                                        <select
                                          type="text"
                                          placeholder="Product"
                                          value={data.product}
                                          onChange={(evnt) =>
                                            handleChange(index, evnt)
                                          }
                                          name="product"
                                          className="form-control"
                                        >
                                          <option value="">
                                            ---{t("Select Product")}---
                                          </option>
                                          <option value="Rental">
                                            {t("Rental")}
                                          </option>
                                          <option value="Lease">
                                            {t("Lease")}
                                          </option>
                                          <option value="Loan">
                                            {t("Loan")}
                                          </option>
                                        </select>
                                      </td>
                                      <td>
                                        <button
                                          className="btn btn-outline-danger "
                                          onClick={() => deleteTableRows(index)}
                                        >
                                          x
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            <div className="text-left py-3">
                              <button
                                style={{ display: "none" }}
                                type="button"
                                className="complete_invoice border-0 btn btn-secondary btn-gradient-primary btn-md"
                              >
                                {t("Complete")}
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handelClick}
                                className="btn-cancel-invoice border-0 btn btn-secondary btn-gradient-primary btn-md"
                              >
                                {t("Cancel")}
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="submit"
                                className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                                disabled={disable}
                              >
                                {loading === false ? (
                                  t("Update")
                                ) : (
                                  <ButtonLoading />
                                )}
                              </button>
                              &nbsp;&nbsp;
                            </div>
                          </>
                        }
                        <CheckButton
                          style={{ display: "none" }}
                          ref={checkBtn}
                        />
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditRateCardHeader;
